export default "__VITE_ASSET__DQummxxA__"